class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminders'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/delete'
			},
			search: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/search'
			},
			enable: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/enable'
			},
			disable: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/disable'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/update'
			},
			insert: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/reminder/insert'
			}
		};
	}
}

export default new APIS();
